module.exports = g_errAIR;